import * as ng from 'angular';
import * as _ from 'underscore';

import {ApiHelperService} from '../../shared';
import {Report, Dataset} from '.';

require('./mapdata');

export class ReportsService {
   static $inject = ['$http', 'apiHelper', 'fileDownload'];

   constructor(
      private $http:ng.IHttpService,
      private apiHelper:ApiHelperService,
      private fileDownload
   )
   { }

   get(id:string):Report {
      return _.findWhere(Report.reports, {id: id});
   }

   getDatasets(...ids:string[]) {
      return this.apiHelper.get("reports/dataSets").then(response => {
         return _.chain(response)
            .filter(r => ids.indexOf(r.id) !== -1)
            .map(r => new Dataset(r))
            .value();
      });
   }

   getMapData(countryCode:string) {
      return this.$http.get(`mapdata/${countryCode}-all.geo.json`);
   }

   data(sourceId:string, args) {
      let url = this.apiHelper.getApiUrl(`reports/data/${sourceId}`, args);
      return this.$http.get(url);

/*    Reports used to run as soon as any input changed, so it was necessary
      to cancel previous requests if inputs where changed in rapid succession.
      This is likely not necessary anymore since reports wait for users to
      choose inputs and explicitly run report. Leaving it here just in case
      it needs to be restored.

      // cancel previous request
      if (this.requestCanceller[sourceId]) {
         // resolving timeout promise on finished request has no effect
         this.requestCanceller[sourceId].resolve();
      }

      this.requestCanceller[sourceId] = this.$q.defer();

      // use of "timeout" is not very expressive
      // when it's a promise, angular will actually abort request when resolved
      return this.$http.get(url, {timeout: this.requestCanceller[sourceId].promise});
*/
   }

   download(sourceId, args, format) {
      args = _.extend({format: format}, args || {});
      new this.fileDownload(this.apiHelper.getApiUrl(`reports/data/${sourceId}`), args).get();
   }
}

ng.module('e360')
   .service('ReportsService', ReportsService);
